export default "__VITE_ASSET__B$OqgSsY__"